import React from 'react';
import PropTypes from 'prop-types';
import { Segment, Label } from 'semantic-ui-react';
import '../style/App.css';
import SocialBar from './SocialBar';
import ContactBar from './ContactBar';
import config from '../config';

const renderLabel = (item) => {
    if(!item){
        return(<Label/>);
    } 
    return (
        <Label style={{...Style.label, ...config.website.footer.style }} key={item.id} compact 
        icon='sidebar' size='large' onClick={item.onClick}>
            {item.text}
        </Label>
    );
}

class Footer extends React.Component{
    render(){
        const list = this.props.items ? 
            this.props.items.map(item => renderLabel(item)): '';

        return(
            <div style={{...Style.main, ...config.website.footer.style }}>
                <Segment.Group vertical>
                <div>
                    {list}
                </div>
                <SocialBar/>
                <ContactBar/>
                <div style={Style.social}> 
                    <a href="http://1cs.ca" target="_blank" rel="noopener noreferrer">@2018 Designed by  1CS</a>
                </div>       
                </Segment.Group>
            </div>
        )
    }

};
Footer.PropTypes = {
    items: PropTypes.array,
};
const Style = {
    main: {
        width: '100%',
        height: 'auto',
        color: '#e1e1a2',
        fontFamily: "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
        //fontSize: '34px',
        fontWeight: '900',
        marginTop: '30px',
        background: 'lightgray'
    },
    label:
    { 
        marginTop: '10px',
        background: 'lightgray',
        color:'white'
    },
    social: {
        //background: 'lightgray',//'#f5f0f0',
        color:'white',
        padding: '5px',
        height: '30px',
        fontSize: '14px',
        fontWeight: '400',
        alignItems: 'center',
    }
}
export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js